import { TranslationMap } from '@trimble-gcs/i18n-types';

export function mapListTranslations() {
  return {
    error: {
      failedToIngest: {
        text: $localize`:@@map.list.error.failedToIngest:Failed to ingest`,
        desc: 'Error message displayed when ingestion failed on a scan in the map-list.',
      },
      loadingData: {
        text: $localize`:@@map.list.error.loadingData:Error loading data. Please try again later.`,
        desc: 'Error message displayed when an error occurs while loading the data in the map-list.',
      },
      notReadyForViewing: {
        text: $localize`:@@map.list.error.notReadyForViewing:Not ready for viewing`,
        desc: 'Error message displayed when a scan is not ready for viewing in the map-list.',
      },
    },
    filterOptions: {
      allData: {
        text: $localize`:@@map.list.filterOptions.allData:All project data`,
        desc: 'The first option in the filter dropdown of the map-list. It shows all project data.',
      },
      georeferencedOnly: {
        text: $localize`:@@map.list.filterOptions.georeferencedOnly:Georeferenced data only`,
        desc: 'The second option in the filter dropdown of the map-list. It shows only data that has been georeferenced.',
      },
    },
    mainTitle: {
      text: $localize`:@@map.list.mainTitle:{Reality Capture} Data`,
      desc:
        'Title displayed at the top of the map-list panel. ' +
        "The term 'Reality Capture' is the product name and is not translated.",
    },
  } satisfies TranslationMap;
}
